import { render, staticRenderFns } from "./QuickReportModal.vue?vue&type=template&id=bf9f6ece&"
import script from "./QuickReportModal.vue?vue&type=script&lang=js&"
export * from "./QuickReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports